import { getValidAccessToken } from 'services/auth';

export const getModelList = async () => {
  const token = await getValidAccessToken();
  const response = await fetch(`${import.meta.env.VITE_LLM_PROXY}models`, {
    headers: {
      authorization: `Bearer ${token}`
    }
  });
  const data = await response.json();

  return data;
};
